import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-subtitle2 q-mt-xs" }
const _hoisted_2 = { class: "text-h5 q-mt-sm" }
const _hoisted_3 = {
  key: 0,
  class: "text-body1 q-mt-sm"
}

import { computed } from 'vue'
import { DateTime } from 'luxon'


export default /*@__PURE__*/_defineComponent({
  __name: 'ShowAppointment',
  props: {
    startDate: {},
    duration: {},
    restBetrag: {}
  },
  setup(__props: any) {

const props = __props

// 📅 Formatiertes Datum
const formattedDate = computed(() => {
  return DateTime.fromJSDate(props.startDate).toLocaleString({
    weekday: 'long',
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  })
})

// 🕒 Startzeit + Endzeit aus Dauer berechnen
const formattedTime = computed(() => {
  const start = DateTime.fromJSDate(props.startDate)
  const end = start.plus({ minutes: props.duration })

  const startTime = start.toLocaleString(DateTime.TIME_24_SIMPLE)
  const endTime = end.toLocaleString(DateTime.TIME_24_SIMPLE)

  return `${startTime} – ${endTime} Uhr`
})

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createBlock(_component_q_card, {
    dark: "",
    class: "q-pa-md q-mx-auto text-center shadow-2 rounded-borders",
    style: {"max-width":"400px"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card_section, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(formattedDate.value), 1),
          _createElementVNode("div", _hoisted_2, _toDisplayString(formattedTime.value), 1),
          (__props.restBetrag)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(__props.restBetrag) + "€ bar vor Ort ", 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})